import { useContext } from 'react'
import { FilterContext } from '../providers/filterProvider'

export const useFilter = () => {
  const {
    filtroExameSetores,
    setFiltroExameSetores,
    filtroExameTipos,
    setFiltroExameTipos,
    filtroExameStatus,
    setFiltroExameStatus,
    filtroExameUsuarioRequisitante,
    setFiltroExameUsuarioRequisitante,
    filtroExameDataSolicitacaoInicio,
    setFiltroExameDataSolicitacaoInicio,
    filtroExameDataSolicitacaoFinal,
    setFiltroExameDataSolicitacaoFinal,
    filtroExameDataSolicitacaoChecked,
    setFiltroExameDataSolicitacaoChecked,
    filtroExameDataAtribuicaoInicio,
    setFiltroExameDataAtribuicaoInicio,
    filtroExameDataAtribuicaoFinal,
    setFiltroExameDataAtribuicaoFinal,
    filtroExameDataAtribuicaoChecked,
    setFiltroExameDataAtribuicaoChecked,
    filtroExameDataFinalizacaoInicio,
    setFiltroExameDataFinalizacaoInicio,
    filtroExameDataFinalizacaoFinal,
    setFiltroExameDataFinalizacaoFinal,
    filtroExameDataFinalizacaoChecked,
    setFiltroExameDataFinalizacaoChecked,
    filtroExameExaminadores,
    setFiltroExameExaminadores,
    filtroExameNumeroProcedimento,
    setFiltroExameNumeroProcedimento,
    filtroExameNumeroDocumento,
    setFiltroExameNumeroDocumento,
    filtroExameDataCriacaoInicio,
    setFiltroExameDataCriacaoInicio,
    filtroExameDataCriacaoFinal,
    setFiltroExameDataCriacaoFinal,
    filtroExameDataCriacaoChecked,
    setFiltroExameDataCriacaoChecked,
    filtroExameDataPublicacaoInicio,
    setFiltroExameDataPublicacaoInicio,
    filtroExameDataPublicacaoFinal,
    setFiltroExameDataPublicacaoFinal,
    filtroExameDataPublicacaoChecked,
    setFiltroExameDataPublicacaoChecked,
  } = useContext(FilterContext)

  return {
    filtroExameSetores,
    setFiltroExameSetores,
    filtroExameTipos,
    setFiltroExameTipos,
    filtroExameStatus,
    setFiltroExameStatus,
    filtroExameUsuarioRequisitante,
    setFiltroExameUsuarioRequisitante,
    filtroExameDataSolicitacaoInicio,
    setFiltroExameDataSolicitacaoInicio,
    filtroExameDataSolicitacaoFinal,
    setFiltroExameDataSolicitacaoFinal,
    filtroExameDataSolicitacaoChecked,
    setFiltroExameDataSolicitacaoChecked,
    filtroExameDataAtribuicaoInicio,
    setFiltroExameDataAtribuicaoInicio,
    filtroExameDataAtribuicaoFinal,
    setFiltroExameDataAtribuicaoFinal,
    filtroExameDataAtribuicaoChecked,
    setFiltroExameDataAtribuicaoChecked,
    filtroExameDataFinalizacaoInicio,
    setFiltroExameDataFinalizacaoInicio,
    filtroExameDataFinalizacaoFinal,
    setFiltroExameDataFinalizacaoFinal,
    filtroExameDataFinalizacaoChecked,
    setFiltroExameDataFinalizacaoChecked,
    filtroExameExaminadores,
    setFiltroExameExaminadores,
    filtroExameNumeroProcedimento,
    setFiltroExameNumeroProcedimento,
    filtroExameNumeroDocumento,
    setFiltroExameNumeroDocumento,
    filtroExameDataCriacaoInicio,
    setFiltroExameDataCriacaoInicio,
    filtroExameDataCriacaoFinal,
    setFiltroExameDataCriacaoFinal,
    filtroExameDataCriacaoChecked,
    setFiltroExameDataCriacaoChecked,
    filtroExameDataPublicacaoInicio,
    setFiltroExameDataPublicacaoInicio,
    filtroExameDataPublicacaoFinal,
    setFiltroExameDataPublicacaoFinal,
    filtroExameDataPublicacaoChecked,
    setFiltroExameDataPublicacaoChecked,
  }
}
